import Vue from "vue";
import Vuex from "vuex";
import { queryMyselfInfoApi } from "@/services/admin_user/index.js";
// import {
//   queryMyselfStore
// } from "@/services/mall/store.js";
//1. 安装
Vue.use(Vuex);
var store = new Vuex.Store({
  state: {
    //TODO:登录后的token,1天失效
    storeToken: "",
    //用户信息: 导航权限 店铺权限
    userInfo: {},
    //全量导航  routerName: "Management"
    navList: [
      {
        id: "1",
        label: "产品介绍",
        icon: "el-icon-s-order",
        routerName: "Welcome",
        path: "/management/welcome",
      },
      //系统管理
      {
        id: "0",
        label: "超级管理员",
        icon: "el-icon-setting",
        routerName: "system",
        disabled: true,
        children: [{
          id: "0-1",
          label: "账号管理",
          routerName: "SysUser",
          path: "/management/system/user",
          disabled: true,
        },
        //给账号分配企业
        {
          id: "0-2",
          path: "accountMapping",
          routerName: "AccountMapping",
          label: "分配企业",
          path: "/management/system/accountMapping",
          disabled: true,
        },
        ],
      },
      {
        id: "2",
        icon: "el-icon-s-platform",
        label: "企业信息管理",
        routerName: "FairInfo",
        path: "/management/fairInfo",
      },
      {
        id: "3",
        label: "AI客服管理",
        icon: "el-icon-upload",
        routerName: "AiService",
        children: [
          {
            id: "3-0",
            label: "创建ai客服",
            routerName: "Robot",
            path: "/management/aiService/robot",
          },
          {
            id: "3-1",
            label: "知识库导入",
            routerName: "KnowledgeBase",
            path: "/management/aiService/knowledgeBase",
          },
          // {
          //   id: "3-3",
          //   label: "关键信息提取配置",
          //   routerName: "PromptArchives",
          //   path: "/management/promptService/archives",
          // },

          // {
          //   id: "6-0",
          //   label: "问诊中心",
          //   icon: "el-icon-s-order",
          //   routerName: "ConsultationControl",
          //   path: "/management/aiService/consultationControl",
          // },
          // {
          //   id: "6-1",
          //   label: "会话记录",
          //   icon: "el-icon-s-order",
          //   routerName: "AiAnswersRecord",
          //   path: "/management/aiService/answersRecord",
          // },
          // {
          //   id: "6-2",
          //   label: "线索表单管理", //修正
          //   icon: "el-icon-s-order",
          //   routerName: "AiArchives",
          //   path: "/management/aiService/archives",
          // },

        ],
      },

      //会话
      {
        id: "4",
        label: "会话管理",
        // icon: "el-icon-s-data",
        icon: "el-icon-s-comment",
        routerName: "Information",
        children: [
          {
            id: "4-1",
            label: "会话记录",
            icon: "el-icon-s-order",
            routerName: "AiAnswersRecord",
            path: "/management/aiService/answersRecord",
          },
          {
            id: "4-2",
            label: "线索表单",
            routerName: "AiArchives",
            path: "/management/aiService/archives",
          },
        ],
      },


      // {
      //   id: "3",
      //   label: "信息概览管理",
      //   // icon: "el-icon-s-data",
      //   icon: "el-icon-s-platform",
      //   // icon: "el-icon-s-shop",
      //   routerName: "Information",
      //   children: [
      //     {
      //       id: "3-1",
      //       label: "医生出诊信息维护",
      //       icon: "el-icon-s-order",
      //       routerName: "InformationList",
      //       path: "/management/information/list",
      //     },
      //     {
      //       id: "3-2",
      //       label: "挂号预约记录",
      //       icon: "el-icon-s-order",
      //       routerName: "InformationReservation",
      //       path: "/management/information/reservation",
      //     },
      //   ],
      // },



      // {
      //   id: "15",
      //   label: "提示词管理",
      //   icon: "el-icon-s-comment",
      //   routerName: "PromptService",
      //   children: [
      //     {
      //       id: "15-1",
      //       label: "问答配置-问诊AI",
      //       routerName: "PromptQuestions_one",
      //       path: "/management/promptService/questions_one",
      //     },
      //     {
      //       id: "15-3",
      //       label: "问答配置-科普AI",
      //       routerName: "PromptQuestions_two",
      //       path: "/management/promptService/questions_two",
      //     },
      //     {
      //       id: "15-4",
      //       label: "问答配置-预约AI",
      //       routerName: "PromptQuestions_three",
      //       path: "/management/promptService/questions_three",
      //     },
      //     {
      //       id: "15-2",
      //       label: "线索表单参数模版配置",
      //       routerName: "PromptArchives",
      //       path: "/management/promptService/archives",
      //     },
      //   ],
      // },
      // {
      //   id: "16",
      //   label: "api余量管理",
      //   icon: "el-icon-star-off",
      //   routerName: "MallVipCard",
      //   path: "/management/vipCard",
      //   children: [{
      //     id: "16-1",
      //     label: "财务账户列表",
      //     routerName: "MallVipCardList",
      //     path: "/management/vipCard/vipCardList",
      //     // disabled: true,
      //   },
      //   {
      //     id: "16-2",
      //     label: "交易记录",
      //     routerName: "MallVipCardRecode",
      //     path: "/management/vipCard/vipCardRecode",
      //   },
      //   {
      //     id: "16-3",
      //     label: "我的财务账户",
      //     routerName: "MallMyAccount",
      //     path: "/management/vipCard/myAccount",
      //   },
      //   ],
      // },

      //个人中心
      {
        id: "5",
        label: "个人中心",
        icon: "el-icon-s-custom",
        routerName: "Person",
        children: [{
          id: "5-1",
          label: "账户信息",
          routerName: "PersonCenter",
          path: "/management/person/center",
        }, {
          id: "5-2",
          label: "token余量",
          routerName: "Payment",
          path: "/management/person/payment",
        },],
      },
    ],
    //登录后筛选的导航
    filterNavList: [],
    //登录后筛选的店铺列表
    filterStoreList: [],
    //高亮导航项
    active: "",
  },
  //变更状态
  mutations: {
    updataUserInfo(state, value) {
      state.userInfo = value;
    },
    updataFilterNavList(state, value) {
      state.filterNavList = value;
    },
    updataFilterStoreList(state, value) {
      state.filterStoreList = value;
    },
    updataActive(state, value) {
      state.active = value;
    },
  },
  // Actions: 异步操作和业务逻辑处理
  actions: {
    /**
     * 获取用户信息并初始化权限和门店信息
     * @description 登录后或刷新页面时调用，完成用户信息、权限、门店等数据的初始化
     * @returns {Promise} 返回包含 code 和 routerName 的对象
     */
    async getUserInfoAction({ commit, state, dispatch }) {
      // 从本地存储获取 token
      const token = localStorage.getItem("token");

      // 调用接口获取用户信息
      const userInfo = await queryMyselfInfoApi({
        token,
      });

      // 用户无权限或 token 失效时拦截
      if (userInfo?.code !== 200 || !userInfo?.data?.role_menu) {
        return new Promise((reslove, reject) => {
          reslove(userInfo);
        });
      }

      // console.log("userInfo:===================", userInfo);

      // 提交用户信息到 state（此时 userInfo 已包含 token）
      commit("updataUserInfo", userInfo?.data);

      // 初始化店铺信息
      // const storeList = await queryMyselfStore({
      //   store_id: userInfo?.data.store_id || "",
      // });
      // commit("updataFilterStoreList", storeList?.data);

      // 根据用户权限初始化导航数据
      // 深拷贝全量导航列表，避免修改原始数据
      var copyNavList = JSON.parse(JSON.stringify(state.navList));
      // 将用户权限字符串转换为数组（如 "0,1,1-1" => ["0", "1", "1-1"]）
      var roleList = state.userInfo.role_menu?.split(",");

      // 递归筛选出用户有权限的导航项
      await dispatch("getFilterNavListAction", {
        copyNavList,
        roleList,
      });

      // 提交筛选后的导航列表
      commit("updataFilterNavList", copyNavList);

      // 返回成功状态，跳转到欢迎页
      return new Promise((reslove, reject) => {
        reslove({
          code: 200,
          routerName: "Welcome",
        });
      });
    },

    /**
     * 根据权限递归筛选出导航列表
     * @description 根据用户权限过滤导航菜单，移除无权限的菜单项
     * @param {Array} copyNavList - 导航列表副本
     * @param {Array} roleList - 用户权限ID列表
     */
    async getFilterNavListAction(
      { dispatch, commit },
      { copyNavList, roleList }
    ) {
      // 从后向前遍历，避免删除元素时索引错乱
      for (var index = copyNavList.length - 1; index >= 0; index--) {
        // 如果当前菜单有子菜单且用户有该菜单权限，递归处理子菜单
        if (
          copyNavList[index]?.children &&
          copyNavList[index]?.children.length > 0 &&
          roleList?.indexOf(copyNavList[index].id) >= 0
        ) {
          await dispatch("getFilterNavListAction", {
            copyNavList: copyNavList[index].children,
            roleList: roleList,
          });
        }
        // 如果用户没有该菜单权限，从列表中移除
        if (roleList?.indexOf(copyNavList[index]?.id) < 0) {
          copyNavList.splice(index, 1);
        }
      }
    },


    /**
     * 查找并激活当前路由对应的导航菜单项
     * @description 递归遍历导航列表,根据路由路径找到对应的菜单项并设置为激活状态
     * @param {Object} context - Vuex action 上下文对象
     * @param {Function} context.dispatch - 分发其他 action
     * @param {Function} context.commit - 提交 mutation
     * @param {Object} payload - 传入参数
     * @param {Array} payload.filterNavList - 过滤后的导航列表
     * @param {String} payload.path - 当前路由路径
     * @returns {Boolean} 是否找到匹配的导航项
     */
    async findActive({ dispatch, commit }, { filterNavList, path }) {
      // 遍历导航列表
      for (let index = 0; index < filterNavList.length; index++) {
        const navItem = filterNavList[index];

        // 找到路径匹配的导航项,更新激活状态
        if (navItem?.path === path) {
          commit("updataActive", navItem.id);
          return true; // 找到后直接返回
        }

        // 如果当前菜单有子菜单且路径不匹配,递归查找子菜单
        if (navItem?.children?.length > 0) {
          const found = await dispatch("findActive", {
            filterNavList: navItem.children,
            path,
          });
          // 子菜单中找到了,提前结束循环
          if (found) return true;
        }
      }
      // 未找到匹配项,清空激活状态
      commit("updataActive", "");
      return false;
    },
  },
});
export default store;